import colors from '@ui/tokens/colors/colors';

// Blue
export const PRIMARY_BASE = colors.blue[ 5 ];
export const PRIMARY_900 = colors.blue[ 7 ];
export const PRIMARY_200 = colors.blue[ 1 ];

// Green
export const SUCCESS = colors.green[ 5 ];
export const SUCCESS_200 = colors.green[ 1 ];
export const SUCCESS_700 = colors.green[ 6 ];

// Orange
export const WARNING_BASE = colors.orange[ 5 ];
export const WARNING_200 = colors.orange[ 1 ];
export const WARNING_700 = colors.orange[ 6 ];

// Red
export const ERROR = colors.red[ 5 ];
export const ERROR_LIGHT = colors.red[ 1 ];
export const STRONG_ERROR = colors.red[ 6 ];

// Gray / Dark
export const NEUTRAL = colors.dark[ 1 ];
export const NEUTRAL_200 = colors.gray[ 1 ];
export const NEUTRAL_700 = colors.dark[ 2 ];
export const NEUTRAL_800 = colors.dark[ 7 ];

export const TEXT_GREY = colors.dark[ 3 ];
export const MIDDLE_GREY = colors.gray[ 4 ];
export const LIGHT_GREY = colors.gray[ 2 ];
export const DARK_GREY = colors.dark[ 2 ];
export const APP_BACKGROUND = colors.gray[ 1 ];

// Black
export const BLACK = '#000000';
export const SECONDARY_DARK = colors.space[ 9 ];

// White
export const WHITE = '#fff';

// Secondary
export const SECONDARY_BASE = colors.space[ 5 ];
export const SECONDARY_PRESSED = colors.space[ 7 ];
export const SECONDARY = colors.space[ 2 ]; // #DBE4F2 => #DAE2EE
export const SECONDARY_0_15 = 'rgba(6, 19, 36, 0.15)';

// Labels
export const CORAL_BASE = '#F5C1CA';
export const CORAL_600 = '#F29FAE';
export const YELLOW_BASE = '#F9F2B4';
export const YELLOW_600 = '#F8ED91';
export const CLAY_BASE = '#FED2B2';
export const CLAY_600 = '#FCBA8A';
export const APPLE_BASE = '#D9EEB7';
export const APPLE_600 = '#CBE79F';
export const AQUA_BASE = '#C3F4F2';
export const AQUA_600 = '#9CEFEA';
export const BLUE_BASE = '#C0D9FF';
export const BLUE_600 = '#9DC4FF';
export const LILAC_BASE = '#DFD0FF';
export const LILAC_600 = '#C7AEFD';
export const PINK_BASE = '#F5CDF1';
export const PINK_600 = '#F1B6EB';
export const FUSCHIA_100 = '#EF5DA8';
export const DARK_GREEN = '#077A38';
export const GREEN_700 = '#008B3B';
export const STONE_BASE = '#E8F0FC';
export const STONE_600 = '#BFCEE3';
export const SILVER_BASE = '#E9E9E9';
export const SILVER_600 = '#D9D9D9';
